import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input
} from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[autoResize]',
  exportAs: 'autoResize'
})
export class AutoResizeDirective implements AfterViewInit {

  @Input() maxLines = 5;
  private lineHeight = 24;

  constructor(
    private el: ElementRef<HTMLTextAreaElement>,
    private ngModel: NgModel
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => this.ajustarAltura());
  }

  @HostListener('input')
  @HostListener('ngModelChange')
  onChange(): void {
    this.ajustarAltura();
  }

  public ajustarAltura(): void {
    const textarea = this.el.nativeElement;

    textarea.style.height = 'auto';

    let height = textarea.scrollHeight;

    if (!textarea.value && textarea.placeholder) {
      height = this.calcularAlturaPlaceholder(textarea);
    }

    const maxHeight = this.maxLines * this.lineHeight;
    textarea.style.height = Math.min(height, maxHeight) + 'px';
  }

  private calcularAlturaPlaceholder(textarea: HTMLTextAreaElement): number {
    const fake = document.createElement('textarea');

    fake.value = textarea.placeholder;
    fake.style.width = textarea.clientWidth + 'px';
    fake.style.font = getComputedStyle(textarea).font;
    fake.style.lineHeight = getComputedStyle(textarea).lineHeight;
    fake.style.padding = getComputedStyle(textarea).padding;
    fake.style.border = 'none';
    fake.style.position = 'absolute';
    fake.style.visibility = 'hidden';
    fake.style.height = 'auto';

    document.body.appendChild(fake);
    const height = fake.scrollHeight;
    document.body.removeChild(fake);

    return height;
  }
}
